import {
  FaLinkedin,
  FaGithub,
  FaYoutube,
  FaXTwitter,
  FaInstagram,
  FaFacebook,
  FaPinterest,
  FaEnvelope,
  FaPhone,
  FaWhatsapp,
} from 'react-icons/fa6';
import Seo from '../components/ui/Seo';
import BlurFade from '../components/ui/BlurFade';
import { social } from '../data/social';

const ICONS = {
  LinkedIn: FaLinkedin,
  GitHub: FaGithub,
  YouTube: FaYoutube,
  X: FaXTwitter,
  Instagram: FaInstagram,
  Facebook: FaFacebook,
  Pinterest: FaPinterest,
  Email: FaEnvelope,
  Call: FaPhone,
  WhatsApp: FaWhatsapp,
};

const Social = () => {
  return (
    <main className="bg-white pb-20 pt-32 text-black">
      <Seo
        title="Social | Prathamesh Shete"
        description="Follow Prathamesh Shete on LinkedIn, GitHub, YouTube, X, Instagram, Facebook, and Pinterest."
        path="/social"
      />

      <div className="mx-auto max-w-4xl px-6">
        <BlurFade>
          <h1 className="mb-3 text-3xl font-black sm:text-4xl">
            Social<span className="text-black/30">.</span>
          </h1>
        </BlurFade>
        <BlurFade delay={0.05}>
          <p className="mb-10 text-black/60">Find me on these platforms.</p>
        </BlurFade>

        <div className="grid grid-cols-2 gap-4 sm:grid-cols-4">
          {social.map(({ label, link }, i) => {
            const Icon = ICONS[label];
            return (
              <BlurFade key={label} delay={(i % 8) * 0.04}>
                <a
                  href={link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex aspect-square flex-col items-center justify-center gap-3 rounded-xl border-2 border-black transition-transform hover:-translate-y-1 hover:shadow-[0_6px_0_0_rgba(0,0,0,1)]"
                >
                  <Icon size={32} />
                  <span className="text-sm font-black">{label}</span>
                </a>
              </BlurFade>
            );
          })}
        </div>
      </div>
    </main>
  );
};

export default Social;
